import { Component } from "react";

class ErrorBoundary extends Component {
  state = { hasError: false, error: null };
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error("ErrorBoundary caught:", error, info); }
  reset = () => { this.setState({ hasError: false, error: null }); window.location.reload(); };
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-md w-full border border-border rounded-sm p-6 bg-card">
          <h2 className="font-display text-2xl tracking-tight mb-2">Algo deu errado</h2>
          <p className="text-sm text-muted-foreground mb-4">Encontramos um erro ao carregar esta página. Clique abaixo para recarregar.</p>
          <pre className="text-[10px] text-muted-foreground bg-muted p-2 rounded-sm overflow-auto mb-4">{String(this.state.error?.message || this.state.error)}</pre>
          <button onClick={this.reset} className="px-4 py-2 bg-primary text-primary-foreground rounded-sm hover:bg-primary/90 text-sm">
            Recarregar
          </button>
        </div>
      </div>
    );
  }
}
export default ErrorBoundary;
